import cmsInstance from 'shared/services/cms';

/** Nested shape for signup.trial-required-credit-card */
export interface DataStoreFlagsSignupTrial {
  hideEmail: boolean;
  createIfExistUser: boolean;
}

/** Nested shape for signup */
export interface DataStoreFlagsSignup {
  'trial-required-credit-card': DataStoreFlagsSignupTrial;
}

/** Full response from /v2/data-store/flags */
export interface DataStoreFlags {
  signup?: DataStoreFlagsSignup;
  wallet?: boolean;
  insurance?: boolean;
  portalStripe?: boolean;
  massivePaymentLinks?: boolean;
}

/**
 * Fetch feature flags from CMS data-store
 */
export const getDataStoreFlags = async (): Promise<DataStoreFlags> => {
  try {
    const { data } = await cmsInstance.get<DataStoreFlags>(
      '/v2/data-store/flags'
    );
    return data ?? {};
  } catch (error) {
    console.error('Error fetching data-store flags:', error);
    return {};
  }
};
